import React, { useCallback } from 'react';
import { GridContainer, Grid } from 'src/shared/grid';
import 'src/features/field-sample/FieldSample.scss';
import Button from '@mui/material/Button';
import { useStoreContext } from 'src/store/context';
import { useAddAlert } from 'src/store/actions';
import { deleteReport } from 'src/apis/mutationsReports';
import { alertMessages } from 'src/constants';

type DeleteReportProps = {
    setDeleteReportSuccess: any,
    setOpenDeleteModal: any,
    setDeleteReport:any,
    deleteReportId:string,
}

export const DeleteReportModal: React.FC<DeleteReportProps> = ({ setDeleteReportSuccess, setOpenDeleteModal, setDeleteReport, deleteReportId }) => {
    const [, dispatch] = useStoreContext();
    const addAlert = useAddAlert(dispatch);

    const deleteReportbyId= useCallback((deleteId) => {
        (async () => {
            try {
                const varRequest = {
                    id: deleteId
                };
                const response: any = await deleteReport(varRequest, addAlert);
                if(response){
                    setDeleteReport(true)
                    setOpenDeleteModal(false)
                    setDeleteReportSuccess(true)
                    setDeleteReport('')
                }
            }
            catch (error) {
                addAlert({
                    id: '',
                    message: alertMessages.reportDelete,
                    type: 'error-info',
                    icon: 'fa-exclamation-triangle'
                })
            }
        })();
    }, [addAlert, setDeleteReport, setOpenDeleteModal, setDeleteReportSuccess]);

    const handleDeleteButton = () =>{
        deleteReportbyId(Number(deleteReportId))
    }

    const handleCancelButton = ()=>{
        setOpenDeleteModal(false);
        setDeleteReport('')
    }
    return (
        <GridContainer className="removePadding" style={{height:'100%', maxHeight:'80%'}}>
            <Grid row gap="md" className='page-heading'>
                <Grid
                    desktop={{ col: 12 }}
                    className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 paddingForModal">

                    <span className="font-sans-lg text-bold">Delete?</span>
                             
                        
                </Grid>
            </Grid>
            <hr style={{ width: '100%', marginBottom: 0 }}></hr>
                

                    <Grid row className="paddingForm2" style={{marginBottom:'1rem'}}>
                      Are you sure you want to delete this item? This will be a permanent delete from the system.
                    </Grid>
             

            <Grid row className='modalBottomDiv'>
                <Grid desktop={{ col: 9 }} className="modalCancelDiv">
                    <Button variant="outlined" style={{ backgroundColor: 'white',textTransform: 'none' }} onClick={() => { handleCancelButton()}}>
                        Cancel
                    </Button>
                </Grid>
                <Grid desktop={{ col: 3 }} className='modalSubmitDiv'>

                    <Button color="error" variant="contained" type="submit" style={{textTransform: 'none'}} onClick={() => { handleDeleteButton() }}>
                        Delete
                    </Button>

                </Grid>
            </Grid>
        </GridContainer>
    )
}